import React from 'react';
import { Col, Row } from 'antd';
import { BankAccountCard } from './bank-account-card';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';

const AccountList = ({ accountList, handleChange, state, activateBank, deleteBank }) => {
	return (
		<Col>
			{accountList.length <= 0 ? (
				<Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '80vh' }}>
					<Row style={{ flexDirection: 'column' }}>
						<Col>
							<ImageComponent src={images.inactiveempty} />
						</Col>
						<Col style={{ fontFamily: 'Gilroy-Semibold', fontSize: '20px', textAlign: 'center', margin: '6px' }}>
							No Inactive accounts
						</Col>
					</Row>
				</Col>
			) : (
				accountList.map((e) => {
					return (
						<Col style={{ margin: '10px 0px' }}>
							<BankAccountCard
								state={state}
								handleChange={handleChange}
								activateBank={activateBank}
								deleteBank={deleteBank}
								bankInfo={e}
							/>
						</Col>
					);
				})
			)}
		</Col>
	);
};
export default AccountList;
